import { Button } from '@factorialco/deprecated-design-system'
import { SpendingPolicyFragment } from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { useDeleteSpendingPolicy } from 'modules/finance/hooks/useSpendingPolicies'

type RemoveModalProps = {
  closeModal: () => void
  spendingPolicy: SpendingPolicyFragment
}

const RemoveModal = ({ closeModal, spendingPolicy }: RemoveModalProps) => {
  const { deleteSpendingPolicy } = useDeleteSpendingPolicy()

  const handleSubmit = async () => {
    const result = await deleteSpendingPolicy(spendingPolicy.id.toString())

    const handled = handleResult(result, () => undefined)

    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t(`spending_policies.delete.flash.success`),
      })
      closeModal()
    } else {
      app.setFlash({
        type: 'wrong',
        message: i18n.t(`spending_policies.delete.flash.error`),
      })

      closeModal()
    }
    return handled
  }

  return (
    <Modal
      illustration="alert"
      title={i18n.t(`spending_policies.delete.modal.title`, { name: spendingPolicy.name })}
      description={i18n.t(`spending_policies.delete.modal.description`)}
      footer={
        <>
          <Button type="secondary" onClick={closeModal}>
            {i18n.t('common.cancel')}
          </Button>
          <Button submit>{i18n.t(`common.delete`)}</Button>
        </>
      }
      onSubmit={handleSubmit}
      onClose={closeModal}
    ></Modal>
  )
}

export default RemoveModal
